module.exports = __webpack_public_path__ + "static/media/West_Midlands_Combined_Authority_logo.2e2a250f.png";